import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { VerificationComponent } from './verification/verification.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { environment } from 'src/environments/environment';
import { SetupPasswordComponent } from './reset-password/setup-password/setup-password.component';
import { TreasuryComponent } from './treasury/treasury.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TreasuryFormComponent } from './treasury/treasury-form-dialog/treasury-form-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { Setup1Component } from './setup/setup1/setup1.component'
import { Setup2Component } from './setup/setup2/setup2.component';
import { Setup3Component } from './setup/setup3/setup3.component';
import { Setup4Component } from './setup/setup4/setup4.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import { NgImageSliderModule } from 'ng-image-slider';
import { BrowserModule } from '@angular/platform-browser';
import { VerificationURLComponent } from './verification-url/verification-url.component';
import { SignUpVerificationURLComponent } from './signup-email-verification/signup-email-verification.component';
import { MyInboxComponent } from './my-inbox/my-inbox.component';


@NgModule({
  declarations: [
    LoginComponent,
    RegistrationComponent,
    VerificationComponent,
    ResetPasswordComponent,
    SetupPasswordComponent,
    TreasuryComponent,
    TreasuryFormComponent,
    Setup1Component,
    Setup2Component,
    Setup3Component,
    Setup4Component,
    VerificationURLComponent,
    SignUpVerificationURLComponent,
    MyInboxComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RecaptchaModule,
    ReactiveFormsModule,
    ImageCropperModule,
    RecaptchaFormsModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    NgImageSliderModule
  ],

  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OnboardingModule { }
